import axios from 'axios';

export const apprenticeApi = {
  getAll: (tenantId: string, instructorId?: string, instructorEmail?: string) => {
    const params: any = {};
    if (instructorId) params.instructor_id = instructorId;
    if (instructorEmail) params.instructor_email = instructorEmail;
    return axios.get(`/api/apprentices/tenant/${tenantId}`, { params });
  },

  getOne: (tenantId: string, id: string) => {
    return axios.get(`/api/apprentices/tenant/${tenantId}/${id}`);
  },

  create: (data: any) => {
    return axios.post('/api/apprentices', data);
  },

  update: (tenantId: string, id: string, data: any) => {
    return axios.patch(`/api/apprentices/tenant/${tenantId}/${id}`, data);
  },

  delete: (tenantId: string, id: string) => {
    return axios.delete(`/api/apprentices/tenant/${tenantId}/${id}`);
  },

  assignInstructor: (tenantId: string, apprenticeId: string, instructorId: string) => {
    return axios.post(`/api/apprentices/tenant/${tenantId}/${apprenticeId}/assign-instructor`, {
      instructor_id: instructorId,
    });
  },

  getInstructorCaseload: (tenantId: string, instructorId: string) => {
    return axios.get(`/api/apprentices/tenant/${tenantId}/instructor/${instructorId}/caseload`);
  },
};
